import Papa from 'papaparse';

const parseCSVWithRetry = async (url, attempt = 0, maxRetries = Infinity) => {
  return new Promise((resolve, reject) => {
    Papa.parse(url, {
      download: true,
      header: true,
      complete: (result) => {
        if (result.errors && result.errors.length > 0) {
          // Check if errors are network-related
          const hasNetworkError = result.errors.some(err => {
            const errorMsg = (err.message || '').toLowerCase();
            return errorMsg.includes('http2') || 
                   errorMsg.includes('network') || 
                   errorMsg.includes('fetch') ||
                   errorMsg.includes('failed');
          });
          
          if (hasNetworkError && attempt < maxRetries - 1) {
            const backoffDelay = Math.min(Math.pow(2, Math.min(attempt, 5)) * 1000, 30000);
            console.warn(`[dataFetching] Attempt ${attempt + 1} failed for ${url} (network error), retrying in ${backoffDelay/1000}s...`);
            setTimeout(() => {
              parseCSVWithRetry(url, attempt + 1, maxRetries).then(resolve).catch(reject);
            }, backoffDelay);
            return;
          }
        }
        resolve(result.data);
      },
      error: (error) => {
        const errorMessage = error?.message || error?.toString() || String(error) || '';
        const errorString = errorMessage.toLowerCase();
        const isNetworkError = 
          errorString.includes('http2') ||
          errorString.includes('err_http2_protocol_error') ||
          errorString.includes('protocol_error') ||
          errorString.includes('failed to fetch') ||
          errorString.includes('networkerror') ||
          errorString.includes('network') ||
          errorString.includes('aborted') ||
          errorString.includes('timeout') ||
          errorString.includes('fetch');
        
        if (isNetworkError && attempt < maxRetries - 1) {
          const backoffDelay = Math.min(Math.pow(2, Math.min(attempt, 5)) * 1000, 30000);
          console.warn(`[dataFetching] Attempt ${attempt + 1} failed for ${url} (network error), retrying in ${backoffDelay/1000}s...`, errorMessage);
          setTimeout(() => {
            parseCSVWithRetry(url, attempt + 1, maxRetries).then(resolve).catch(reject);
          }, backoffDelay);
        } else {
          reject(error);
        }
      },
    });
  });
};

export const fetchData = async (holeDataUrl, assayDataUrl, holeColumns, assayColumns) => {
  try {
    const holeData = await parseCSVWithRetry(holeDataUrl);
    const assayData = await parseCSVWithRetry(assayDataUrl);

    const holes = {};
    const assays = {};
    holeData.forEach((hole) => {
      const holeId = hole[holeColumns['Hole No']];
      if(holeId && holeId.length >= 1) {
        holes[holeId] = { ...hole };
      }
    });

    assayData.forEach((assay) => {
      const holeId = assay[assayColumns['HoleID']];
      if (holeId) {
        if (!assays[holeId]) {
          assays[holeId] = [];
        }
        assays[holeId].push({ ...assay });
      }
    });

    return { holes, assays };
  } catch (error) {
    // Re-throw to let calling code handle retries if needed
    throw error;
  }
};
